import { useRef, useState } from "react";
import QuizSection from "./QuizSection";
import KeyTakeAway from "./KeyTakeAway";
import ToggleButton from "./components/ToggleButton";
import ChatSection from "./ChatSection";
import PersonalisedForYou from "./PersonalisedForYou";
import LearnTubeXIllustartion from "./components/LearnTubeXIllustartion";
import { useSelector } from "react-redux";
import { selectSubscriptionStatus } from "../../redux/personaliseLessons/subscriptionStatusSlice";
import { selectBottomIllustationStatus } from "../../redux/personaliseLessons/bottomIllustration";
import { selectAuthentication } from "../../redux/personaliseLessons/authenticationSlice";
import { selectCourseList } from "../../redux/personaliseLessons/courseListSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamation } from "@fortawesome/free-solid-svg-icons";

const DesktopOtherSection = ({
  lessonName,
  userGoal,
  setUserGoal,
  course_slug,
  lesson_slug,
  module_slug,
  lessonDetails,
  moduleName,
  isToggled,
  setIsToggled,
  quizRef,
}) => {
  const subscriptionStatus = useSelector(selectSubscriptionStatus);
  const bottomIllustrationStatus = useSelector(selectBottomIllustationStatus);
  const authentication = useSelector(selectAuthentication);
  const subject_name = useSelector(selectCourseList)?.courseName;

  const [showKeyPoints, setShowKeyPoints] = useState(false);
  const [showQuiz, setShowQuiz] = useState(true);
  const [showAskCreator, setShowAskCreator] = useState(false);
  const [isAtEnd, setIsAtEnd] = useState(false);

  const sentinelRef1 = useRef(null);

  const handleToggle = (index) => {
    if (index === 0) {
      setShowQuiz(true);
      setShowAskCreator(false);
      setShowKeyPoints(false);
    } else if (index === 1) {
      setShowQuiz(false);
      setShowAskCreator(false);
      setShowKeyPoints(true);
    } else if (index === 2) {
      setShowQuiz(false);
      setShowAskCreator(true);
      setShowKeyPoints(false);
    }
  };

  return (
    <div className="flex w-full flex-col pb-4 lg:mt-5 lg:px-6 lg:pb-6">
      <h3 className="max-lg:hidden text-2xl font-medium">{lessonName}</h3>
      <div className="max-lg:text-center max-lg:justify-between max-lg:px-2 mt-4 flex gap-3 overflow-x-scroll border-b border-[#196BBD]">
        <div
          className={`max-lg:flex-1 max-lg:text-sm reactour-desktop-quizsection reactour-quizsection flex cursor-pointer items-center justify-center text-xl leading-5 lg:w-[175px] ${
            showQuiz
              ? "border-b-4 border-[#7FC241] font-bold text-[#7FC241]"
              : "text-[#4F6E8D]"
          } pb-3`}
          onClick={() => handleToggle(0)}
        >
          <h3>Quiz</h3>
          {lessonDetails?.lesson_status !== "completed" && (
            <div className="ml-2 flex h-5 w-5 items-center justify-center rounded-full border-2 border-[#F59E0B] ">
              <FontAwesomeIcon
                icon={faExclamation}
                className="text-sm text-[#F59E0B]"
              />
            </div>
          )}
        </div>
        <div
          className={`max-lg:flex-1 max-lg:text-sm reactour-desktop-keypoints reactour-keypoints flex cursor-pointer items-center justify-center text-xl leading-5 lg:w-[175px] ${
            showKeyPoints
              ? "border-b-4 border-[#7FC241] font-bold text-[#7FC241]"
              : "text-[#4F6E8D]"
          } pb-3`}
          onClick={() => handleToggle(1)}
        >
          <h3>Key Takeways</h3>
        </div>
        <div
          className={`max-lg:flex-1 max-lg:text-sm reactour-desktop-chatsection reactour-chatsection flex cursor-pointer items-center justify-center text-xl leading-4 lg:w-[175px] ${
            showAskCreator
              ? "border-b-4 border-[#7FC241] font-bold text-[#7FC241]"
              : "text-[#4F6E8D]"
          } pb-3`}
          onClick={() => handleToggle(2)}
        >
          <h3>Ask The Creator</h3>
        </div>
      </div>
      <div ref={quizRef}>
        {showQuiz && (
          <QuizSection
            userGoal={userGoal}
            setUserGoal={setUserGoal}
            course_slug={course_slug}
            lesson_slug={lesson_slug}
            module_slug={module_slug}
            moduleName={moduleName}
          />
        )}
        {showKeyPoints && (
          <div className="reactour-keypoints relative mt-5 rounded-xl px-4">
            <div className="hidden items-center justify-between">
              <h2 className="text-2xl font-semibold">Key Takeaways</h2>
              <PersonalisedForYou />
            </div>
            <div className="mt-3 rounded-lg bg-[#2D4F71]">
              <KeyTakeAway
                course_slug={course_slug}
                userGoal={userGoal}
                setUserGoal={setUserGoal}
                lesson_slug={lesson_slug}
              />
            </div>
          </div>
        )}
        {showAskCreator && (
          <>
            <div className="mt-5 mb-3 flex items-center justify-between px-4">
              <h2 className="flex-1 text-2xl font-semibold">Ask The Creator</h2>
              <div className="mt-1 flex items-center justify-between">
                <div className="mr-2 h-[16.7px] w-[15px]">
                  <img
                    src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/Vector.png?updatedAt=1689172663353"
                    alt=""
                    className="h-full w-full"
                  />
                </div>
                <p className="mr-2 text-sm">Audio</p>
                <ToggleButton
                  isToggled={isToggled}
                  setIsToggled={setIsToggled}
                />
              </div>
            </div>
            <div className="px-4">
              <ChatSection
                lesson_id={lessonDetails?.lesson_id}
                course_slug={course_slug}
                video_id={
                  lessonDetails?.video_url?.split("?")?.[1]?.split("=")?.[1]
                }
                isToggled={isToggled}
                lessonDetails={lessonDetails}
              />
            </div>
          </>
        )}
      </div>
      {subscriptionStatus?.type === "course_purchased" ||
      bottomIllustrationStatus?.show_banner ? (
        <div className="p-4 lg:hidden">
          <LearnTubeXIllustartion
            sentinelRef={sentinelRef1}
            isAtEnd={isAtEnd}
            setIsAtEnd={setIsAtEnd}
            course_slug={subject_name}
            authentication={authentication}
          />
        </div>
      ) : (
        <div className="h-4 w-full"></div>
      )}
    </div>
  );
};

export default DesktopOtherSection;
